import { useState } from "react";
import { appUrl } from "../utils/appUrl.js";

export function CopySlug({slug,color}) {
  const [copied,setCopied]=useState(false);
  const copy=()=>{navigator.clipboard?.writeText(appUrl(slug));setCopied(true);setTimeout(()=>setCopied(false),2000);};
  const base = (import.meta.env.VITE_APP_URL ?? "").replace(/\/$/, "") || (typeof window !== "undefined" ? window.location.origin : "");
  const displayPrefix = base.replace(/^https?:\/\//, "") + "/";
  return (
    <button onClick={copy} style={{display:"inline-flex",alignItems:"center",gap:5,background:"#0d1724",border:"1px solid #1e2d45",borderRadius:8,padding:"5px 11px",fontSize:12,color:"#64748b",fontFamily:"monospace",cursor:"pointer",maxWidth:"100%",overflow:"hidden"}}>
      <span style={{color:"#334155",flexShrink:0,maxWidth:160,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{displayPrefix}</span>
      <span style={{color,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{slug}</span>
      <span style={{color:copied?"#22c55e":"#475569",flexShrink:0,marginLeft:2}}>{copied?"✓":"⎘"}</span>
    </button>
  );
}

export default CopySlug;
